import React, { useContext, useState } from 'react';

import { ReactComponent as Foto } from '../../../assets/novosicones/notificacoes/camera.svg';

import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';

import { ContextNotificacoes } from '../../../services/notificacoes';

import { ContextGetData } from '../../../services/getData';

import { useHistory } from 'react-router-dom';

import { Spinner } from '../../StyledComponent';

import ManutencaoPeriodica from './ManutencaoPeriodica';

const Fotos = ({ tema, setNotificationsModal }) => {
  const NOTIFICATIONSFOTOS = JSON.parse(
    sessionStorage.getItem('notificationsFotos')
  );

  const NOTIFICATIONSMANUTENCAOPERIODICA = JSON.parse(
    sessionStorage.getItem('notificationsManutencaoPeriodica')
  );

  const { setImovelNotificacao, setExecutarScroll } = useContext(
    ContextoListaApartamentos
  );

  const [fotoSelecionada, setFotoSelecionada] = useState('');

  const { importDataHome, home, filtraImovel } = useContext(ContextGetData);

  const { marcarFotoLido, atualizaNotificacoes, handleNotificationError } =
    useContext(ContextNotificacoes);

  const [loading, setLoading] = useState(false);

  async function marcarFotosComoLido(id) {
    await marcarFotoLido(id);

    let temp = NOTIFICATIONSFOTOS.filter((foto) => foto.Id != id);
    sessionStorage.setItem('notificationsFotos', JSON.stringify(temp));

    await atualizaNotificacoes();
  }

  const history = useHistory();

  function redirectToMeuHome(empreendimentoIdSalesForce) {
    setImovelNotificacao(empreendimentoIdSalesForce);

    setExecutarScroll(true);
    history.push({
      pathname: '/interna',
    });
  }

  const verificaSeFotoNotificacaoExiste = async (
    idsalesforce,
    EmpreendimentoIdSalesForce
  ) => {
    if (home) {
      return verificaFoto(EmpreendimentoIdSalesForce, idsalesforce, home);
    } else {
      let { imoveis } = await importDataHome();
      return verificaFoto(EmpreendimentoIdSalesForce, idsalesforce, imoveis);
    }
  };

  const verificaFoto = async (
    EmpreendimentoIdSalesForce,
    idsalesforce,
    imoveis
  ) => {
    let imovelNotificacao = await filtraImovel(
      EmpreendimentoIdSalesForce,
      imoveis
    );

    if (imovelNotificacao[0]?.empreendimento?.imagens.length) {
      let tempFilter = imovelNotificacao[0].empreendimento.imagens.filter(
        (imagem) => imagem.idSalesForce == idsalesforce
      );
      if (tempFilter.length > 0) return true;
    }
  };

  const handleVisualizar = async (
    Id,
    EmpreendimentoIdSalesForce,
    IdSalesForce
  ) => {
    await marcarFotosComoLido(Id);

    if (
      await verificaSeFotoNotificacaoExiste(
        IdSalesForce,
        EmpreendimentoIdSalesForce
      )
    ) {
      redirectToMeuHome(EmpreendimentoIdSalesForce);
      setLoading(false);
      setNotificationsModal(false);
    } else {
      handleNotificationError();
    }
  };

  let checkIfNewPhoto = [];

  if (NOTIFICATIONSFOTOS?.length > 0)
    checkIfNewPhoto = NOTIFICATIONSFOTOS.filter((item) => {
      return !item.Visualisado;
    });

  if (
    checkIfNewPhoto.length == 0 &&
    NOTIFICATIONSMANUTENCAOPERIODICA.length == 0
  )
    return null;

  return (
    <div className='notifications__item'>
      <span
        className='notifications__item__title'
        style={{ color: tema.primaryColor }}
      >
        Minha obra:
      </span>
      {NOTIFICATIONSFOTOS?.map((foto) => {
        return (
          <div className='centralized-space-between' key={foto.Id}>
            <div className='centralized'>
              <Foto style={{ fill: tema.primaryColor }} />
              <p
                className='notifications__item__description'
                style={{ color: '#454545' }}
              >
                Atualizamos as fotos da sua obra, confira!
              </p>
            </div>
            {loading && fotoSelecionada == foto.Id ? (
              <Spinner />
            ) : (
              <a
                style={{ color: tema.primaryColor, cursor: 'pointer' }}
                onClick={() => {
                  setLoading(true);
                  setFotoSelecionada(foto.Id);
                  handleVisualizar(
                    foto.Id,
                    foto.EmpreendimentoIdSalesForce,
                    foto.IdSalesForce || foto.IdAws
                  );
                }}
              >
                VISUALIZAR
              </a>
            )}
          </div>
        );
      })}

      <ManutencaoPeriodica
        tema={tema}
        setNotificationsModal={setNotificationsModal}
      />
    </div>
  );
};

export default Fotos;
